export default "__VITE_ASSET__CplOwB5X__"